import * as React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { reduxForm, Field } from 'redux-form';

import { PHONE_FINALIZE } from 'af-constants/reduxForms';

import Checkbox from 'af-fields/Checkbox';

import SubmitButton from 'af-components/SubmitButton';

import CLIENT from 'af-routes/client';

import * as AuthenticationActions from 'af-actions/authentication';

import { PhoneFinalizeFM } from './formModel';
import styles from './styles.module.scss';
import CarrierNotice from '../Shared/Finalize/CarrierNotice';
import FinalizeDescription from '../Shared/Finalize/FinalizeDescription';
import NotificationsCompliance from '../Shared/Finalize/NotificationsCompliance';
import PrivacyPolicyCompliance from '../Shared/Finalize/PrivacyPolicyCompliance';

type FormOwnProps = ConnectedProps<typeof connector>;
type Props = FormOwnProps & InjectedFormProps<PhoneFinalizeFM, FormOwnProps>;

const PhoneFinalize: React.FC<Props> = (props) => {

	const {
		handleSubmit,
		submitting,
		invalid,
		phoneFinalize,
	} = props;

	const location = useLocation();
	const navigate = useNavigate();
	const orgAlias = location.state.orgAlias;

	const submit = React.useCallback(async () => {
		if (!orgAlias) {
			throw new Error('Not enough information about the organization to finalize.');
		}
		await phoneFinalize(orgAlias);
		navigate(CLIENT.HOME(orgAlias));
	}, [navigate, phoneFinalize, orgAlias]);

	return (
		<div className="form-segment form-segment--mini">
			<div className={`form-box form-box--standalone ${styles.container__padded}`}>
				<Form onSubmit={handleSubmit(submit)}>
					<Row>
						<Col sm={24}>
							<FinalizeDescription instructions="Please comply with the following to proceed:" />
						</Col>
					</Row>
					<Row>
						<Col sm={24}>
							<Field
								capitalize={false}
								component={Checkbox}
								id="confirmedPrivacyPolicy"
								label={<PrivacyPolicyCompliance />}
								name="confirmedPrivacyPolicy"
							/>
						</Col>
					</Row>
					<Row>
						<Col sm={24}>
							<Field
								capitalize={false}
								component={Checkbox}
								id="confirmedToReceiveWorkNotifications"
								label={<NotificationsCompliance />}
								name="confirmedToReceiveWorkNotifications"
							/>
						</Col>
					</Row>
					<Row>
						<CarrierNotice />
					</Row>
					<Row className={`${styles.submitButton} row--submit`}>
						<SubmitButton
							disabled={invalid}
							fullWidth={true}
							label="Submit"
							reduxFormSubmitting={submitting}
							size="big"
							variant="primary"
						/>
					</Row>
				</Form>
			</div>
		</div>
	);
};

function mapDispatchToProps() {
	return {
		phoneFinalize: AuthenticationActions.phoneFinalize,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentClass>(
	React.memo,
	reduxForm<PhoneFinalizeFM, FormOwnProps>({ form: PHONE_FINALIZE, validate: PhoneFinalizeFM.validate }),
	connector
);

export default enhance(PhoneFinalize);
